import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "vac-name-container vac-text-ellipsis" }
const _hoisted_2 = { class: "vac-title-container" }
const _hoisted_3 = {
  key: 0,
  class: "vac-text-date"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "vac-text-ellipsis"
}
const _hoisted_6 = {
  key: 2,
  class: "d-flex align-items-center w-80"
}
const _hoisted_7 = {
  key: 3,
  class: "vac-text-ellipsis"
}
const _hoisted_8 = { class: "vac-room-options-container" }
const _hoisted_9 = {
  key: 0,
  class: "vac-badge-counter vac-room-badge"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "vac-menu-options"
}
const _hoisted_12 = { class: "vac-menu-list" }
const _hoisted_13 = ["onClick"]

import {
	CustomAction,
	CustomActions,
	StringNumber,
	TextFormatting,
	Room,
} from "vue-advanced-chat";
import SvgIcon from "vue-advanced-chat/src/components/SvgIcon/SvgIcon.vue";
import FormatMessage from "vue-advanced-chat/src/components/FormatMessage/FormatMessage.vue";
import typingText from "vue-advanced-chat/src/utils/typing-text.js";
import { isAudioFile } from "vue-advanced-chat/src/utils/media-file.js";
import { computed, ref } from "vue";
import { TicketModule } from "@/store/modules/Ticket";

type RoomProps = {
	room: Room;
	currentUserId: string | number;
	textMessages?: Record<string, StringNumber>;
	textFormatting?: TextFormatting;
	linkOptions?: {
		disabled: false;
		target: string;
		rel: unknown;
	};
	roomActions?: CustomActions;
};

export default /*#__PURE__*/_defineComponent({
  props: {
    room: null,
    currentUserId: null,
    textMessages: null,
    textFormatting: { default: () => ({
		disabled: false,
		italic: "_",
		bold: "*",
		strike: "~",
		underline: "°",
		multilineCode: "```",
		inlineCode: "`",
	}) },
    linkOptions: { default: () => ({ disabled: false, target: "_blank", rel: null }) },
    roomActions: { default: () => [] }
  },
  emits: ["room-action-handler"],
  setup(__props: any, { emit }: { emit: ({
	(
		e: "room-action-handler",
		value: { action: CustomAction; roomId: string | number }
	): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { room: Room, currentUserId: string | number, textMessages?: Record<string, StringNumber>, textFormatting: TextFormatting, linkOptions: {
		disabled: false;
		target: string;
		rel: unknown;
	}, roomActions: CustomActions }





const roomMenuOpened = ref<string | number | null>(null);

const typingUsers = computed(() => {
	return typingText(props.room, props.currentUserId, props.textMessages);
});
const isMessageCheckmarkVisible = computed(() => {
	return (
		!typingUsers.value &&
		props.room.lastMessage &&
		!props.room.lastMessage.deleted &&
		props.room.lastMessage.senderId === props.currentUserId &&
		(props.room.lastMessage.saved ||
			props.room.lastMessage.distributed ||
			props.room.lastMessage.seen)
	);
});
const isAudio = computed(() => {
	return props.room.lastMessage?.files
		? isAudioFile(props.room.lastMessage?.files[0])
		: false;
});
const formattedDuration = computed(() => {
	const file = props.room.lastMessage?.files?.[0];
	if (!file?.duration) {
		return `${file?.name}.${file?.extension}`;
	}
	let s = Math.floor(file.duration);
	return (s - (s %= 60)) / 60 + (s > 9 ? ":" : ":0") + s;
});

const getLastMessage = computed(() => {
	const isTyping = typingUsers.value;
	if (isTyping) return isTyping;

	const content = props.room.lastMessage?.deleted
		? props.textMessages?.MESSAGE_DELETED
		: props.room.lastMessage?.content;

	if (props.room.users.length <= 2) {
		return content;
	}

	const user = props.room.users.find(
		user => user._id === props.room.lastMessage?.senderId
	);

	if (props.room?.lastMessage?.username) {
		return `${props.room.lastMessage.username} - ${content}`;
	} else if (!user || user._id === props.currentUserId.toString()) {
		return content;
	}

	return `${user.username} - ${content}`;
});

// Methods
function roomActionHandler(action: CustomAction) {
	closeRoomMenu();
	emit("room-action-handler", { action, roomId: props.room.roomId });
}

function closeRoomMenu() {
	roomMenuOpened.value = null;
}
function assignRoom() {
	// console.log(props.room.roomId, "hola roommenuopened");
	roomMenuOpened.value = props.room.roomId;
}

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "room-list-avatar", _normalizeProps(_guardReactiveProps({ room: __props.room })), () => [
      (__props.room.avatar)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "vac-avatar",
            style: _normalizeStyle({ 'background-image': `url('${__props.room.avatar}')` })
          }, null, 4))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(
					'vac-room-name vac-text-ellipsis' +
						(__props.room.lastMessage?.origin === 'client' ? ' font-weight-bold' : '')
				)
        }, _toDisplayString(__props.room.roomName), 3),
        (__props.room.lastMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "room-list-item-date", _normalizeProps(_guardReactiveProps({ room: __props.room })), () => [
                _createTextVNode(_toDisplayString(__props.room.lastMessage.timestamp), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["vac-text-last", {
				'vac-message-new':
					__props.room.lastMessage && __props.room.lastMessage.new && !_unref(typingUsers),
			}])
      }, [
        (_unref(isMessageCheckmarkVisible))
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
              _renderSlot(_ctx.$slots, "checkmark-icon", _normalizeProps(_guardReactiveProps({ message: __props.room.lastMessage })), () => [
                _createVNode(SvgIcon, {
                  name: 
							__props.room.lastMessage?.distributed ? 'double-checkmark' : 'checkmark'
						,
                  param: __props.room.lastMessage?.seen ? 'seen' : '',
                  class: "vac-icon-check"
                }, null, 8, ["name", "param"])
              ])
            ]))
          : _createCommentVNode("", true),
        (__props.room.lastMessage && !__props.room.lastMessage.deleted && _unref(isAudio))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _renderSlot(_ctx.$slots, "microphone-icon", {}, () => [
                _createVNode(SvgIcon, {
                  name: "microphone",
                  class: "vac-icon-microphone"
                })
              ]),
              _createTextVNode(" " + _toDisplayString(_unref(formattedDuration)), 1)
            ]))
          : (__props.room.lastMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (__props.room.lastMessage.icon)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      class: _normalizeClass(["mr-1", __props.room.lastMessage.icon])
                    }, null, 2))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(
						'w-100' +
							(__props.room.lastMessage?.origin === 'client' ? ' font-weight-bold' : '')
					)
                }, [
                  _createVNode(FormatMessage, {
                    content: _unref(getLastMessage),
                    deleted: !!__props.room.lastMessage.deleted && !_unref(typingUsers),
                    users: __props.room.users,
                    linkify: false,
                    "text-formatting": __props.textFormatting,
                    "link-options": __props.linkOptions,
                    "single-line": true
                  }, {
                    "deleted-icon": _withCtx((data) => [
                      _renderSlot(_ctx.$slots, "deleted-icon", _normalizeProps(_guardReactiveProps(data)))
                    ]),
                    _: 3
                  }, 8, ["content", "deleted", "users", "text-formatting", "link-options"])
                ], 2)
              ]))
            : _createCommentVNode("", true),
        (!__props.room.lastMessage && _unref(typingUsers))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(typingUsers)), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          (__props.room.unreadCount)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(__props.room.unreadCount), 1))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "room-list-options", _normalizeProps(_guardReactiveProps({ room: __props.room })), () => [
            (__props.roomActions.length &&
							!(__props.roomActions.length === 1 && __props.roomActions[0].name === 'openPanel' && __props.room.roomId !== _unref(TicketModule).currentRoomID))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "vac-svg-button vac-list-room-options",
                  onClick: _withModifiers(assignRoom, ["stop"])
                }, [
                  _renderSlot(_ctx.$slots, "room-list-options-icon", {}, () => [
                    _createVNode(SvgIcon, {
                      name: "dropdown",
                      param: "room"
                    })
                  ])
                ], 8, _hoisted_10))
              : _createCommentVNode("", true),
            (__props.roomActions.length)
              ? (_openBlock(), _createBlock(_Transition, {
                  key: 1,
                  name: "vac-slide-left"
                }, {
                  default: _withCtx(() => [
                    (roomMenuOpened.value === __props.room.roomId)
                      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.roomActions, (action) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: action.name
                              }, [
                                (
											!(
												action.name === 'openPanel' &&
												__props.room.roomId !== _unref(TicketModule).currentRoomID
											)
										)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "vac-menu-item",
                                      onClick: _withModifiers(() => roomActionHandler(action), ["stop"])
                                    }, _toDisplayString(action.customTitle
												? action.customTitle(__props.room)
												: action.title), 9, _hoisted_13))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ])
                        ])), [
                          [_directive_click_outside, closeRoomMenu]
                        ])
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ], 2)
    ])
  ], 64))
}
}

})